/*
 * Copyright (c) 2022. American Express Company
 */

import React from 'react';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import LiteralsService from 'src/services/literals/LiteralsService';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import { HELP_DOMAIN } from 'src/utils/constants';
import Typography from 'src/components/typography/Typography';
import Card from 'src/components/atomic/atoms/card/Card';
import colors from 'src/styles/colors.module.scss';

import { props } from 'src/types/view-models/planRecap.view.model';

const HELP_LINK_URL: string = HELP_DOMAIN ? `${HELP_DOMAIN}/articles/plan-action-items` : null;

export default function PlanRecap({ userStatus }: props): JSX.Element {
    return (
        <Card showBackgroundBanner>
            <Typography variant={TypographyVariants.BODY_BOLD}>
                {LiteralsService.getLiteral('Insights.planRecap.yourPlanIs')}
            </Typography>
            {userStatus === 'on-track' ? (
                <Typography variant={TypographyVariants.HEADING_XL} className={colors.brand}>
                    {LiteralsService.getLiteral('Insights.planRecap.onTrack')}
                </Typography>
            ) : (
                <Typography variant={TypographyVariants.HEADING_XL} className={colors.warning}>
                    {LiteralsService.getLiteral('Insights.planRecap.offTrack')}
                </Typography>
            )}
            <Typography variant={TypographyVariants.SUBTEXT}>
                <Typography component="span" variant={TypographyVariants.SUBTEXT_BOLD}>
                    {LiteralsService.getLiteral('Insights.planRecap.needNewCopy')}
                </Typography>
                {LiteralsService.getLiteral('Insights.planRecap.yourPlanStatus')}
                <Anchor href={HELP_LINK_URL}>{LiteralsService.getLiteral('Insights.planRecap.learnMore')}</Anchor>
            </Typography>
        </Card>
    );
}
